export default "__VITE_ASSET__CKF$sbXU__"